import { render } from "./AuthForm.vue?vue&type=template&id=d9d7c25a&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import "./AuthForm.vue?vue&type=style&index=0&id=d9d7c25a&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d7c25a"]])

export default __exports__